var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20768 9.16669C3.20768 5.87599 5.87532 3.20835 9.16602 3.20835C12.4567 3.20835 15.1243 5.87599 15.1243 9.16669C15.1243 12.4574 12.4567 15.125 9.16602 15.125C5.87532 15.125 3.20768 12.4574 3.20768 9.16669ZM9.16602 1.79169C5.09292 1.79169 1.79102 5.09359 1.79102 9.16669C1.79102 13.2398 5.09292 16.5417 9.16602 16.5417C10.9475 16.5417 12.5814 15.91 13.8561 14.8585L16.1651 17.1676C16.4418 17.4442 16.8903 17.4442 17.1669 17.1676C17.4435 16.8909 17.4435 16.4424 17.1669 16.1658L14.8578 13.8568C15.9094 12.5821 16.541 10.9482 16.541 9.16669C16.541 5.09359 13.2391 1.79169 9.16602 1.79169Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7af9e04ce23d2f8e462caaec4b00755b.svg";
export { ForwardRef as ReactComponent };